import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tab, TabPane } from 'semantic-ui-react'
import { Folder, getCloudStorageDashboardData } from '~/api/services/dashboard'
import Layout from '~/components/Layout'
import CooperativeDashboard from '~/pages/Farmer/Dashboard/Tabs/CooperativeDashboard'
import MilkPriceDashboard from '~/pages/Farmer/Dashboard/Tabs/MilkPriceDashboard'
import MoohDashboard from '~/pages/Farmer/Dashboard/Tabs/MoohDashboard'
import { handleErrors } from '~/utils/helpers'

const ManagerDashboard: React.FC = () => {
  const { t } = useTranslation()

  const [activeTabIndex, setActiveTabIndex] = useState<string | number>(0)
  const [folders, setFolders] = useState<Folder[]>([])
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    fetchData()
  }, [t])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await getCloudStorageDashboardData()
      setFolders(response.data.folders)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderDashboards() {
    const panes = [
      {
        menuItem: t('Milk money'),
        render: () => <MoohDashboard/>,
        key: 'mooh'
      },
      {
        menuItem: t('Milk price'),
        render: () => <MilkPriceDashboard />,
        key: 'mooh-milk-price'
      }
    ];

    const folderPanes = folders.map(folder => ({
      menuItem: folder.title,
      render: () => <TabPane>
        <CooperativeDashboard files={folder.files}/>
      </TabPane>
    }))

    return <Tab
      menu={{ secondary: true, pointing: true }}
      activeIndex={activeTabIndex}
      panes={[...panes, ...folderPanes]}
      onTabChange={(_, data) => setActiveTabIndex(data.activeIndex)}
    />
  }

  return <Layout
    segmented
    title={''}
    removeHeader
    isBusy={isBusy}
  >
    {renderDashboards()}
  </Layout>
}

export default ManagerDashboard
